import { render, staticRenderFns } from "./EditCommentDialog.vue?vue&type=template&id=3a6d079c&"
import script from "./EditCommentDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCommentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports